import "reflect-metadata";
import { createApp } from "vue";
import App from "@/App.vue";
import { coreContainerBuilder } from "@/core/core-container";
import router from "@/core/router/router";
import store from "@/core/store/index";
import axios from "axios";
import i18n from "./i18n";
import { baseUrl } from "@/core/utils/config";
import "@/core/libs/bootstrap-registrar";
import "@/core/libs/font-awesome-registrar";
import "@/app/libs/app-font-awesome-registrar";
import "@/core/router/navigation-guards";
import "@/core/interceptors/auth-interceptor";
import { appContainerBuilder } from "@/app/app-container";
import { PermissionDirective } from "@/core/plugins/permissions";
import "@/core/interceptors/api-error-interceptors";
import { FeatureDirective } from "@/core/plugins/features";
import oidcStoreModule from "@/core/store/modules/oidc-module";
import mitt from "mitt";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "@progress/kendo-theme-default/dist/all.css";
import { createBootstrap } from "bootstrap-vue-next";
import { DialogInstaller } from "@progress/kendo-dialog-vue-wrapper";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fas);

const app = createApp(App);

PermissionDirective(app);
FeatureDirective(app);
app.use(createBootstrap());
app.use(DialogInstaller);

app.component("font-awesome-icon", FontAwesomeIcon);

axios.defaults.baseURL = baseUrl();

app.use(Toast, { hideProgressBar: true });

export const eventBus = mitt();

coreContainerBuilder();
appContainerBuilder();
store.registerModule("oidcStore", oidcStoreModule);
app.use(i18n);
app.use(router);
app.use(store);

app.mount("#app");
